// Pop Energy — Social Post design #6.
//
// Ported from the Claude Design "Fashion - Social Post" bundle
// (fashion-posts.jsx PostPop). Renders at fixed 1080×1080.
//
// Visual: saturated yellow canvas, oversized Space Grotesk headline with
// rotated highlight on the em phrase, pink curvy blob holding the product
// with a circular "Newdrop" tag in the corner. Energetic / streetwear-pop.
//
// The "Newdrop" tag is a stylized graphic element rather than a copy slot;
// it stays hardcoded to preserve the design's visual identity.

import type { SocialPostSlots } from '@/lib/api';
import './PostPop.css';

interface PostPopProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostPop({ slots, productImageUrl }: PostPopProps) {
  // Mono handle render — strip a leading '@' if present so we can render
  // the '@' as a separately-coloured glyph (matches the source design).
  const handleClean = (slots.handle || '').replace(/^@/, '');

  return (
    <div className="post-pop">
      <div className="frame-pad">
        <div className="top">
          <div className="eyebrow"><span className="blob" /> {slots.eyebrow}</div>
          <div className="badge">
            <span className="stars">{slots.badge_stars}</span>
            <span>{slots.badge_text}</span>
          </div>
        </div>
        <div className="core">
          <div className="headline-wrap">
            <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
          </div>
          <div className="product-wrap">
            <div className="product-frame">
              <div className="blob" />
              <div className="slot">
                {productImageUrl ? (
                  <img src={productImageUrl} alt="Product" />
                ) : (
                  <div className="empty-state">Product image</div>
                )}
              </div>
              <div className="price-tag">New<span>drop</span></div>
            </div>
          </div>
          <div className="left-body">
            <div className="sub">{slots.subhead}</div>
            <ul className="bullets">
              <li><span className="pill">01</span> {slots.bullet1}</li>
              <li><span className="pill">02</span> {slots.bullet2}</li>
              <li><span className="pill">03</span> {slots.bullet3}</li>
            </ul>
          </div>
        </div>
        <div className="bot">
          <div className="handle"><span className="at">@</span>{handleClean}</div>
          <div className="cta">{slots.cta} <span className="arr">→</span></div>
        </div>
      </div>
    </div>
  );
}
